/**
 * @param {unknown} code
 * @param {Array<{ value: string, label: string, flagUrl?: string|null }>} options
 * @returns {{ value: string, label: string, flagUrl?: string|null }|null}
 */
export function nationalityMeta(code, options = []) {
    const key = String(code ?? '').trim().toUpperCase();

    if (key === '') {
        return null;
    }

    return options.find((item) => item.value === key) ?? null;
}
